import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export interface SmartReminder {
  id: string;
  reminder_type: string;
  related_entity_type: string;
  related_entity_id: string | null;
  target_employee_id: string;
  reminder_date: string;
  priority: string;
  message: string;
  action_url: string | null;
  is_sent: boolean;
  metadata: Record<string, any>;
  created_at: string;
  employees?: {
    id: string;
    name: string;
  };
}

export const useSmartReminders = (employeeId?: string) => {
  return useQuery({
    queryKey: ["smart-reminders", employeeId],
    queryFn: async () => {
      let query = supabase
        .from("smart_reminders")
        .select(`
          *,
          employees(id, name)
        `)
        .order("reminder_date", { ascending: true });

      if (employeeId) {
        query = query.eq("target_employee_id", employeeId);
      }

      const { data, error } = await query;

      if (error) throw error;
      return data as SmartReminder[];
    },
  });
};

export const useDismissReminder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (reminderId: string) => {
      const { data, error } = await supabase
        .from("smart_reminders")
        .delete()
        .eq("id", reminderId)
        .select()
        .single();

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["smart-reminders"] });
      toast.success("تم إغلاق التذكير");
    },
    onError: (error) => {
      toast.error("فشل في إغلاق التذكير: " + error.message);
    },
  });
};